// The Game Day icon for the logged-in user's league: football (NFL, NCAAF), baseball (MLB),
// basketball (NBA), soccer ball (MLS), hockey (NHL). Unknown leagues keep the baseball.
import React, { useContext } from 'react';
import SportsBaseballIcon from '@mui/icons-material/SportsBaseball';
import SportsFootballIcon from '@mui/icons-material/SportsFootball';
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import SportsHockeyIcon from '@mui/icons-material/SportsHockey';
import AuthContext from '../../contexts/auth-context';

const ICONS = {
  nfl: SportsFootballIcon,
  ncaaf: SportsFootballIcon,
  mlb: SportsBaseballIcon,
  nba: SportsBasketballIcon,
  mls: SportsSoccerIcon,
  nhl: SportsHockeyIcon,
};

export const sportIconFor = (league) => ICONS[String(league || '').toLowerCase()] || SportsBaseballIcon;

const SportIcon = (props) => {
  const authCtx = useContext(AuthContext);
  const Sport = sportIconFor(authCtx?.league);
  return <Sport {...props} />;
};

export default SportIcon;
